import { Button, Loader, Typography, } from "@bracket/ui";
import { useVaults, } from "@store";
import type { FunctionComponent, } from "react";
import styled from "styled-components";



export const Kyc: FunctionComponent = () => {

	const {
		ready,
		activeAdminVault,
	} = useVaults();

	if(!ready)
		return <Loader />;

	if(!activeAdminVault)
		throw new Error("no active admin vault found");

	return (
		<Container>
			<Typography variant="h1">KYC</Typography>
			<Typography variant="paragraphMD">Here we will display a table of KYC applicants and their status.</Typography>
			<KYCRow>
				<Typography variant="paragraphMD">jane@doe.com</Typography>
				<Typography variant="paragraphMD">0x123123123123</Typography>
				<Button label="Download KYC inquiry" onClick={() => {}} />
				<Button label="Approve" onClick={() => {}} />
				<Button label="Decline" onClick={() => {}} />
				<Button label="Request Revision" onClick={() => {}} />
			</KYCRow>
		</Container>
	);

};

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 32px;
	min-height: 50rem;
`;

const KYCRow = styled.div`
	display: grid;
	grid-template-columns: 5fr 2fr 1fr 1fr 1fr 1fr;
	align-items: center;
	gap: 8px;
`;

const CardContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 8px;
	@media (min-width: 768px) {
		display: flex;
		gap: 12px;
		> * {
			flex: 1;
			width: 100%;
		}
	}
`;
